import { createFileRoute } from "@tanstack/react-router";
import { Flex } from "@radix-ui/themes";
import Footer from "@/components/nav/Footer";
import AboutContent from "@/components/about/AboutContent";
import { seoHead } from "@/lib/seo";

const TITLE = "About Us | Lutely";
const DESCRIPTION =
  "Lutely is where artists sell their music direct, keep their ownership, and get paid up to 100% of every sale. Meet the founders and team behind Lutely.";

export const Route = createFileRoute("/about-us")({
  component: AboutPage,
  head: () =>
    seoHead({
      title: TITLE,
      description: DESCRIPTION,
      canonicalPath: "/about-us",
    }),
});

function AboutPage() {
  return (
    <Flex direction="column" className="bg-white">
      <AboutContent />
      <Footer />
    </Flex>
  );
}
